import { render, staticRenderFns } from "./Expandable.vue?vue&type=template&id=eb6585ee&scoped=true&"
import script from "./Expandable.vue?vue&type=script&lang=js&"
export * from "./Expandable.vue?vue&type=script&lang=js&"
import style0 from "./Expandable.vue?vue&type=style&index=0&id=eb6585ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6585ee",
  null
  
)

export default component.exports